import { type ColumnDef } from "@tanstack/react-table"
import type { ICase } from "@apis/cases/types"
import { DateCell, TruncatedTooltipCell } from "@utils/table/columnFactories"

export const casesColumns: ColumnDef<ICase>[] = [
  {
    header: "Created",
    accessorKey: "case_created_dt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "Tier",
    accessorKey: "case_type_description",
  },
  {
    header: "Reason",
    accessorKey: "category_name",
  },
  {
    header: "Channel",
    accessorKey: "channel_name",
  },
  {
    header: "Market Code",
    accessorKey: "market_code",
  },
  {
    header: "Status",
    accessorKey: "case_status_name",
  },
  {
    header: "Description",
    accessorKey: "case_description",
    cell: (props) => <TruncatedTooltipCell {...props} />,
  },
  {
    header: "Last Note",
    accessorKey: "last_note",
  },
  {
    header: "Last Changed",
    accessorKey: "updated_at",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "Work Began",
    accessorKey: "work_begins_dt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "Closed",
    accessorKey: "closed_dt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "Created By",
    accessorKey: "email",
  },
  {
    header: "Reported By",
    accessorKey: "reported_name",
  },
  {
    header: "Sales Agent Name",
    accessorKey: "agent_name",
  },
  {
    header: "Office",
    accessorKey: "office_code",
  },
  {
    header: "Assigned To",
    accessorKey: "assigned_to_user_name",
  },
  {
    header: "Disposition",
    accessorKey: "case_status_change_reason_desc",
  },

  {
    header: "Due",
    accessorKey: "requested_close_dt",
    cell: (props) => <DateCell {...props} />,
  },
]
